//dependencies
import $ from "jquery";

export default function() {

    function initScript() {

        if($("#facultyFinder").length > 0) {
            // Faculty Data Initial load
            getFacultyData("");

            $("#facultySearchBtn").on("click", function(e){
                e.preventDefault();
                getFacultyData("");
            });

            $("#pickDepartment").on("change", function(){
                getFacultyData("");
            });

            $("body").on("click", "#letterFilters a", function(){
                var letter = $(this).text();
                getFacultyData(letter);
            });

            // On show more click
            $(".load-more").on("click", function() {
                showMore();
            });
        }
    }

    function showMore()
    {   
        var showAmount = 6;
        var $facultyResults = $("#facultyResults");

        $facultyResults.find("div.faculty-tile:hidden:lt(" + showAmount + ")").show();

        // if there are no more results, hide the load more button.
        if($facultyResults.find("div.faculty-tile:hidden").length <= 0){
            $(".load-more").hide();
        }

    }

    function getFacultyData(letter)
    {
        var department = $("#pickDepartment").val();

        if(department == "All Departments"){
            department = "";
        }

        $.ajax({
            url: window.curry.facultyFeed,
            type: "GET",
            data: {
                Keyword: $("#facultySearch").val(),
                Department: department,
                Letter: letter
            },
            success: function (response) {
                var $facultyResults = $("#facultyResults");
                $facultyResults.html(response);

                var showAmount = 6;

                // Only show a certain amount.
                var $tiles = $facultyResults.find(".faculty-tile");
                
                $tiles.hide();
                
                $facultyResults.find("div.faculty-tile:lt(" + showAmount + ")").show();

                // Determine if the load more button should show up.
                if($facultyResults.find("div.faculty-tile:hidden").length <= 0){
                    $(".load-more").hide();
                }
                else {
                    $(".load-more").show();
                }
            },
            error: function (xhr) {
                //Do Something to handle error
                alert("An error has occurred. Please contact an andministrator.");
            }
        });
    }

    initScript();
}


// WEBPACK FOOTER //
// ./src/ui/js/apps/faculty.js